import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/")({
  loader: () => redirect({ to: "/identity-and-access/home" }),
  staticData: {
    title: "home.title",
  },
});
